import React, { useRef, useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import oncommit from "../../assets/oncommit.png";
import avatarVideo from "../../assets/bg/diagnostico-1-avatar.webm";
import avatarVideoMp4 from "../../assets/bg/diagnostico-1-avatar.mp4";
import manuelVideo from "../../assets/bg/diagnostico-1-manuel.webm";
import manuelVideoMp4 from "../../assets/bg/diagnostico-1-manuel.mp4";
import flechaAvanzar from "../../assets/right-arrow.svg";
import { modalPresentacionManuel } from "../../utils/logger";
import ScenarioBar from "../../components/ScenarioBar";

import { useVideoWithSound } from "../../hooks/useVideoWithSound";

function Scenario2Intro({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	
	const { videoRef, canPlayWithSound } = useVideoWithSound({ 
		autoPlay: true, 
		volume: 0.8
	});

	const [canOpenDialog, setCanOpenDialog] = useState(false);

	const transcription = "Me hicieron los estudios que me indicó y me los enviaron. No sé bien qué significa todo eso, lo único que quiero es que me expliquen claro qué tengo... Y qué opciones hay para mí, solo que ahora no encuentro el informe..."

	const handleContinue = () => {
		navigate(ROUTES.SCENARIO2_INTRO2);
	};

	const abrirModal = () => {
		if (videoRef.current) {
			videoRef.current.pause();
		}
		modalPresentacionManuel(transcription, manuelVideo, manuelVideoMp4, handleContinue, flechaAvanzar, canPlayWithSound, 0.8, "orange");
	};

	const activeScenario = getScenarioNumByPath(location.pathname);

	useEffect(() => {
		const timer = setTimeout(() => setCanOpenDialog(true), 20000);
		return () => clearTimeout(timer);
	}, []);

	return (
		<div className="h-100">
			<div className="container-fluid position-relative h-100">
				<div className="row h-100 d-flex align-items-center">
					<div className="col-md-4 d-flex flex-column justify-content-between h-100 px-4 pb-4">
						<img
							src={oncommit}
							alt="decorativo"
							style={{
								maxWidth: "60%",
							}}
						/>
						<video
							ref={videoRef}
							className="mb-4 pb-5"
							autoPlay
							playsInline
							preload="auto"
							muted={!canPlayWithSound}
							onEnded={() => setCanOpenDialog(true)}
							onError={() => setCanOpenDialog(true)}
						>
							<source src={avatarVideoMp4}  type="video/mp4" />
							<source src={avatarVideo} type="video/webm" />
						</video>
					</div>

					{/* Columna derecha: espacio visual */}
					<div className="col-md-8 d-flex flex-column justify-content-end align-items-end bg-diagnostico-a h-100 px-5">
						<div className="recuadro recuadro-orange txtTexto1 w-100">
							<p>Llegas al hospital y te encuentras a Manuel en tu consulta.</p>
							<p>Entre los datos clínicos se oculta la clave para guiar el tratamiento. Es tu momento de participar.</p>
							<div className="d-flex justify-content-center">
								<div
								    className={`button-escuchar-paciente button-escuchar-paciente-orange mt-4 mb-4 ${!canOpenDialog ? "is-disabled" : ""}`}
									aria-disabled={!canOpenDialog}
									onClick={canOpenDialog ? abrirModal : undefined}
									style={!canOpenDialog ? { pointerEvents: "none" } : undefined}
								>
									Escuchar al paciente
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default injectIntl(Scenario2Intro);
